import { render, staticRenderFns } from "./tselect.vue?vue&type=template&id=204b724e"
import script from "./tselect.vue?vue&type=script&lang=js"
export * from "./tselect.vue?vue&type=script&lang=js"
import style0 from "./tselect.vue?vue&type=style&index=0&id=204b724e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports